export const diagnostico = {
  hero: {
    title: "Strategic Assessment",
    subtitle: "Structured technical analysis for wealth decisions via regulated consortium."
  },
  indicatedFor: {
    title: "Indicated for",
    items: [
      "Real estate acquisition with medium-term planning",
      "Construction or renovation with disciplined credit structure",
      "Wealth planning with technical governance",
      "Corporate structuring via regulated consortium",
      "Analysis of contemplated letters for strategic use"
    ]
  },
  whatWillBeDetailed: {
    title: "What will be detailed",
    items: [
      "Analysis of wealth profile and stated objective",
      "Scenario modeling (base and stress) according to regulations",
      "Execution structure and operational variables",
      "Technical monitoring until credit utilization"
    ]
  },
  howItWorks: {
    title: "How it works",
    steps: [
      {
        number: "01",
        title: "Form Submission",
        description: "You fill out the form with wealth information and objective."
      },
      {
        number: "02",
        title: "Technical Analysis",
        description: "Our team analyzes feasibility, regulations and execution structure."
      },
      {
        number: "03",
        title: "Structured Return",
        description: "You receive technical assessment with modeled scenarios and next steps."
      }
    ]
  },
  form: {
    title: "Request Assessment",
    fields: {
      name: "Full name",
      whatsapp: "WhatsApp",
      email: "E-mail",
      objective: "Objective",
      objectiveOptions: {
        placeholder: "Select objective",
        acquisition: "Real Estate Acquisition",
        construction: "Construction/Renovation",
        planning: "Wealth Planning",
        companies: "Corporate Structuring",
        contemplated: "Contemplated Letter"
      },
      assetValue: "Asset value (R$)",
      comfortableInstallment: "Comfortable installment (R$)",
      horizon: "Horizon (months)",
      alreadyParticipates: "Already participating in consortium?",
      hasContemplatedCard: "Have contemplated letter?",
      yes: "Yes",
      no: "No"
    },
    button: "Request Strategic Assessment",
    success: "Assessment requested successfully. We will return within 48 business hours.",
    error: "Error sending. Try again or contact via WhatsApp."
  },
  governance: {
    title: "Governance",
    text: "Contemplation cannot be guaranteed. There is no promise of fixed return. Costs and conditions (administration fee and reserve fund) vary according to regulations and administrator. This assessment is a technical analysis, not a promise of results."
  },
  finalCta: {
    title: "Prefer to speak directly?",
    subtitle: "Our team is available via WhatsApp to clarify doubts before the assessment.",
    button: "Talk to Specialist"
  },
  faq: {
    title: "Frequently Asked Questions",
    subtitle: "Common questions about the assessment process and regulated consortium.",
    items: [
      {
        question: "What is the FGT Capital Strategic Assessment?",
        answer: "It is a structured technical analysis of your wealth profile and stated objective. Based on the information provided, our team models scenarios, evaluates regulatory feasibility and proposes an appropriate execution structure — without any promise of results."
      },
      {
        question: "How long does it take to receive a response after submitting?",
        answer: "The response is made within 48 business hours after the form is submitted. Contact is made via the WhatsApp or email provided."
      },
      {
        question: "Is there any cost for the assessment?",
        answer: "No. The Strategic Assessment is free and without obligation. It is a preliminary analysis to verify alignment between your objective and available solutions."
      },
      {
        question: "Is contemplation guaranteed?",
        answer: "No. Contemplation depends on the group's regulations, assembly dynamics and any bids. The assessment structures scenarios and execution, but does not guarantee timelines or results."
      },
      {
        question: "Does consortium have interest rates?",
        answer: "There are no interest charges. However, an administration fee and reserve fund apply, with percentages varying according to the regulations and administrator. These costs are detailed during the assessment."
      },
      {
        question: "What is the minimum amount to participate?",
        answer: "There is no single minimum value — it depends on the type of consortium, the group and the objective. During the assessment, our team presents available ranges compatible with your profile."
      },
      {
        question: "Can I use the consortium for business purposes?",
        answer: "Yes. FGT Capital structures operations via consortium for legal entities, including asset acquisition, expansion and corporate wealth planning. Select 'Corporate Structuring' in the form."
      },
      {
        question: "What is a contemplated letter?",
        answer: "It is a consortium quota that has already been contemplated, available for immediate credit use. FGT Capital performs technical curation of these letters, evaluating regularity, administrator and transfer conditions before any indication."
      }
    ]
  }
};